export const WellnessAddonsForm = {
  AddonPrefx: 'wellness-addon',
  SubmitBtn: 'submit-btn',
} as const;
